"use client";

import { useEffect } from "react";
import ErrorPage from "@/components/ui/ErrorPage";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorPage
      code={500}
      description="Na serveru došlo k chybě. Zkuste to prosím znovu."
      action={{ label: "Zkusit znovu", onClick: reset }}
    />
  );
}
